<template>
  <div class="main-box">
    <keep-alive>
      <router-view></router-view>
    </keep-alive>
  </div>
</template>

<script>
import autofit from 'autofit.js'
export default {
  name: '',
  components: {
    
  },
  data() {
    return {
      
    };
  },
  mounted(){
    autofit.init({
      dh: 1080,
      dw: 1920,
      el:"main-box",
      resize: true,
    },
      false
    );
  },
  beforeDestroy(){
    autofit.off();
  },
  props: {
    
  },
  computed: {
    
  },
  methods: {
    
  },
  created() {
    
  }
}
</script>

<style scoped lang="less">
/*  */
.main-box {
  width: 100%;
  height: 100%;
}
</style>